const RECON_BLOTTER_PREFIX = 'principal/reconciliation';
export const RECON_MISMATCHES_BLOTTER_PREFIX = `${RECON_BLOTTER_PREFIX}-mismatches`;
export const RECON_STATUSES_BLOTTER_PREFIX = `${RECON_BLOTTER_PREFIX}-statuses`;
